const { cxt } = require('./context');

const {
  sales,
} = require('../schema');

const {
  collateral,
} = sales;

/**
 * Validates the VX Collateral Motor Vehicle from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxCollateralMotorVehicleValidator = [
  cxt('schema', { schema: collateral.motorVehicle }),
];

/**
 * Validates the VX Collateral Invoices from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const salesVxCollateralInvoiceValidator = [
  cxt('schema', { schema: collateral.invoice }),
];

module.exports = {
  salesVxCollateralMotorVehicle: salesVxCollateralMotorVehicleValidator,
  salesVxCollateralInvoice: salesVxCollateralInvoiceValidator,
};
